import { render } from "./goods-edit.vue?vue&type=template&id=5bea9ce8"
import script from "./goods-edit.vue?vue&type=script&lang=js"
export * from "./goods-edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__